// Talles y colores — maestros por organización (curvas de talles y colores).
// Tablas: talle_curvas, colores. Interruptor: organizations.enable_variant_stock.

import { parseTalleList } from './variantStock.js';

export const CURVAS_SUGERIDAS = [
  { nombre: 'Adulto XS-XXL', valores: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
  { nombre: 'Jean 36-48', valores: ['36', '38', '40', '42', '44', '46', '48'] },
  { nombre: 'Calzado 35-45', valores: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
  { nombre: 'Niños 2-16', valores: ['2', '4', '6', '8', '10', '12', '14', '16'] },
  { nombre: 'Único', valores: ['Único'] },
];

export const COLORES_SUGERIDOS = [
  { nombre: 'Negro', hex: '#111111', codigo_corto: 'NEG' },
  { nombre: 'Blanco', hex: '#FFFFFF', codigo_corto: 'BLA' },
  { nombre: 'Gris', hex: '#9CA3AF', codigo_corto: 'GRI' },
  { nombre: 'Azul', hex: '#1D4ED8', codigo_corto: 'AZU' },
  { nombre: 'Azul marino', hex: '#1E2A4A', codigo_corto: 'MAR' },
  { nombre: 'Rojo', hex: '#DC2626', codigo_corto: 'ROJ' },
  { nombre: 'Verde', hex: '#15803D', codigo_corto: 'VER' },
  { nombre: 'Beige', hex: '#D6C7A1', codigo_corto: 'BEI' },
  { nombre: 'Marrón', hex: '#7C4A21', codigo_corto: 'MAR2' },
  { nombre: 'Rosa', hex: '#F472B6', codigo_corto: 'ROS' },
  { nombre: 'Amarillo', hex: '#FACC15', codigo_corto: 'AMA' },
  { nombre: 'Violeta', hex: '#7C3AED', codigo_corto: 'VIO' },
];

const HEX_RE = /^#[0-9A-Fa-f]{6}$/;

export const normalizeHex = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return null;
  const withHash = raw.startsWith('#') ? raw : `#${raw}`;
  return HEX_RE.test(withHash) ? withHash.toUpperCase() : null;
};

export const buildColorCode = (nombre) =>
  String(nombre || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 3);

/** Devuelve solo los sugeridos que la organización todavía no tiene (por nombre, sin mayúsculas). */
export const missingSuggestions = (existentes, sugeridos) => {
  const nombres = new Set((Array.isArray(existentes) ? existentes : []).map((x) => String(x?.nombre || '').trim().toLowerCase()));
  return (Array.isArray(sugeridos) ? sugeridos : []).filter((x) => !nombres.has(String(x.nombre).trim().toLowerCase()));
};

export const validateCurva = ({ nombre, valoresTexto }) => {
  const valores = parseTalleList(valoresTexto);
  if (!String(nombre || '').trim()) return { ok: false, error: 'Poné un nombre a la curva.' };
  if (!valores.length) return { ok: false, error: 'Cargá al menos un talle (ej.: S, M, L, XL).' };
  return { ok: true, value: { nombre: String(nombre).trim(), valores } };
};

export const validateColor = ({ nombre, hex, codigo_corto }) => {
  if (!String(nombre || '').trim()) return { ok: false, error: 'Poné un nombre al color.' };
  const normalizedHex = hex ? normalizeHex(hex) : null;
  if (hex && !normalizedHex) return { ok: false, error: 'El código de color tiene que ser tipo #1A2B3C.' };
  return {
    ok: true,
    value: {
      nombre: String(nombre).trim(),
      hex: normalizedHex,
      codigo_corto: String(codigo_corto || '').trim().toUpperCase() || buildColorCode(nombre),
    },
  };
};

// --- acceso a datos --------------------------------------------------------------

export const fetchMaestrosTalleColor = async (supabase, organizationId) => {
  const [curvasRes, coloresRes] = await Promise.all([
    supabase.from('talle_curvas').select('*').eq('organization_id', organizationId).order('nombre'),
    supabase.from('colores').select('*').eq('organization_id', organizationId).order('orden').order('nombre'),
  ]);
  if (curvasRes.error) throw curvasRes.error;
  if (coloresRes.error) throw coloresRes.error;
  return { curvas: curvasRes.data || [], colores: coloresRes.data || [] };
};

export const setEnableVariantStock = async (supabase, organizationId, enabled) => {
  const { error } = await supabase
    .from('organizations')
    .update({ enable_variant_stock: Boolean(enabled) })
    .eq('id', organizationId);
  if (error) throw error;
};

export const cargarSugeridos = async (supabase, organizationId, { curvas = [], colores = [] } = {}) => {
  const nuevasCurvas = missingSuggestions(curvas, CURVAS_SUGERIDAS);
  const nuevosColores = missingSuggestions(colores, COLORES_SUGERIDOS);
  if (nuevasCurvas.length) {
    const { error } = await supabase.from('talle_curvas')
      .insert(nuevasCurvas.map((c) => ({ ...c, organization_id: organizationId })));
    if (error) throw error;
  }
  if (nuevosColores.length) {
    const baseOrden = colores.length;
    const { error } = await supabase.from('colores')
      .insert(nuevosColores.map((c, i) => ({ ...c, orden: baseOrden + i, organization_id: organizationId })));
    if (error) throw error;
  }
  return { curvas: nuevasCurvas.length, colores: nuevosColores.length };
};
